/**
 * Dynamically loads the Gainsight PX script with the provided key.
 * This is called at runtime after loading config.json, enabling
 * single-build deployment with environment-specific Gainsight keys.
 */
export function initializeGainsight(gainsightKey: string): void {
  if (!gainsightKey) {
    console.warn('Gainsight key not provided, skipping initialization');
    return;
  }

  // Initialize the aptrinsic global queue
  const win = window as Window &
    typeof globalThis & {
      aptrinsic?: ((...args: unknown[]) => void) & {
        q?: unknown[];
        p?: string;
        c?: unknown;
      };
    };

  win.aptrinsic =
    win.aptrinsic ||
    function (...args: unknown[]) {
      win.aptrinsic!.q = win.aptrinsic!.q || [];
      win.aptrinsic!.q.push(args);
    };
  win.aptrinsic.p = gainsightKey;

  // Create and inject the script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://web-sdk.aptrinsic.com/api/aptrinsic.js?a=${gainsightKey}`;

  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode?.insertBefore(script, firstScript);
}
